import {Store} from "../../models/stores/Store";
import { getQueryParams, StoreLocationsParams } from "../../models/requests/queryParams/StoreLocationsParams";
import { getAuthenticatedRequest, RequestStoreLocations } from "../../models/requests/RequestStoreLocations";
import { StoreLocationsResponse } from "../../models/requests/responses/StoreLocationsResponse";
import { fromError } from 'zod-validation-error';


export async function fetchStoreLocations(
  api: RequestStoreLocations,
  signal: AbortSignal,
  params: StoreLocationsParams,
): Promise<StoreLocationsResponse> {
  const queryParams = getQueryParams(params);

  const request = fetch(getAuthenticatedRequest(api, 'addresses', queryParams, signal))
  return request.then(async (response) => {
    if (!response.ok) {
      throw new Error(response.statusText);
    }

    const jsonData = await response.json();
    let storeResponse: StoreLocationsResponse;

    try {
      storeResponse = StoreLocationsResponse.parse(jsonData);
    } catch (err) {
      console.log(fromError(err).toString());
      throw err;
    }

    return storeResponse!;
  })
}

export async function fetchStoreById(
  api: RequestStoreLocations,
  id: number,
): Promise<Store> {
  const request = fetch(getAuthenticatedRequest(api, `addresses/id/${id}`))
  return request.then(async (response) => {
    if (!response.ok) {
      throw new Error(response.statusText);
    }

    const jsonData = await response.json();
    let storeResponse: Store;

    try {
      storeResponse = Store.parse(jsonData.data);
    } catch (err) {
      console.log(fromError(err).toString());
      throw err;
    }

    return storeResponse!;
  })
}

